/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { useState, useEffect, Fragment } from "react";
import AddWebService from "./AddWebService";
import MaterialTable, { MTableToolbar } from "material-table";
import { forwardRef } from "react";
import Actions from "../../fluid/Actions/ActionFactory";
import {
  Grid,
  Typography,
  Button,
  Divider,
  Chip,
  IconButton,
  Tooltip,
} from "@material-ui/core";

import CheckCircle from "@material-ui/icons/CheckCircle";
import HighlightOff from "@material-ui/icons/HighlightOff";
import Add from "@material-ui/icons/Add";
import Delete from "@material-ui/icons/Delete";
import Refresh from "@material-ui/icons/Refresh";
import AutoRenew from "@material-ui/icons/Autorenew";
import AutorenewTwoToneIcon from "@material-ui/icons/AutorenewTwoTone";
import Edit from "@material-ui/icons/Edit";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import ErrorMessageAlert from "../Utilities/ErrorMessageAlert";
import EditWebService from "./EditWebService";
import EditOutlined from "@material-ui/icons/EditOutlined";
import { DeleteConfirmationDialog } from "./../Utilities/DeleteConfirmationDialog";

import SecureWrapper from "../Security/SecureWrapper";
import { allowedByOpop } from '../Security/SecureCheck';

export default function WebServiceList() {
  const [wsData, setWSData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [addWSOpen, setAddWSOpen] = useState(false);
  const [editWSOpen, setEditWSOpen] = useState(false);

  const [deletingItem, setDeletingItem] = useState({});
  const [editingItem, setEditingItem] = useState({});

  const [errorInfo, setErrorInfo] = useState({});
  const [errorOpen, setErrorOpen] = React.useState(false);

  const [confirmDeleteDialogOpen, setConfirmDeleteDialogOpen] = React.useState(
    false
  );

  const tableIcons = {
    // Add: () => {
    //   return <button>add</button>;
    // },
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => (
      <Delete style={{ color: "#f44336" }} {...props} ref={ref} />
    )),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => (
      <Edit style={{ color: "#757575" }} {...props} ref={ref} />
    )),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  //add
  const handleClickAddNewWS = () => {
    setAddWSOpen(true);
  };
  const handleAddWSClose = ({ refreshList }) => {
    setAddWSOpen(false);
    if (refreshList) {
      fetchWebServiceListAndUpdateTable();
    }
  };

  //edit
  const handleClickEditWS = (rowData) => {
    setEditingItem(rowData);
    setEditWSOpen(true);
  };

  const handleEditWSClose = ({ refreshList }) => {
    setEditWSOpen(false);
    if (refreshList) {
      fetchWebServiceListAndUpdateTable();
    }
  };
  const udpateRow = (updatedWServerInfo) => {
    let updatedData = wsData.map((wvInfo) => {
      if (wvInfo.name === updatedWServerInfo.name) {
        return updatedWServerInfo;
      }
      return wvInfo;
    });
    setWSData(updatedData);
    handleEditWSClose({ refreshList: false });
  };

  const cancelDelete = () => {
    setConfirmDeleteDialogOpen(false);
    setDeletingItem({});
  };

  const confirmDelete = () => {
    setConfirmDeleteDialogOpen(false);
    Actions("http_request", {
      url: `/sainapse/web_service/${deletingItem["name"]}`,
      method: "delete",
      data: {},
    })
      .then((response) => {
        if (response.data.deleted) {
          let updatedData = wsData.filter((row) => {
            return row.name !== deletingItem.name;
          });
          setWSData(updatedData);
          setDeletingItem({});
        }
      })
      .catch((err) => {
        setDeletingItem({});
        setErrorOpen(true);
        setErrorInfo(err);
      });
  };

  //delete
  const handleClickDeleteWS = (rowData) => {
    setDeletingItem(rowData);
    setConfirmDeleteDialogOpen(true);
  };

  //error
  const handleErrorClose = () => {
    setErrorOpen(false);
    setErrorInfo("");
  };

  const getDisableStatus = (name) => {
    
    return !allowedByOpop({
      operation : "/sainapse/web_service/{name}",
      method : "DELETE",
      operands : [
        {
          attrName: "name",
          value : name
    }]
    })
  };

  const renderActions = (row_data) => {
    if (row_data.name !== deletingItem.name || confirmDeleteDialogOpen) {
      return (
        <div
          style={{ display: "flex", flexDirection: "row", margin: "10px 0" }}
        >
          <Tooltip title="Edit" arrow>
            <IconButton
              size="small"
              style={{ marginRight: "0px" }}
              onClick={() => handleClickEditWS(row_data)}
              disabled = {!allowedByOpop({
                operation : `/sainapse/web_service/{name}`,
                method : "PUT",
                operands : [
                  {
                    attrName: "name",
                    value : row_data.name
              }]
            })}
            >
              <EditOutlined fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete" arrow>
            <IconButton
              size="small"
              style={{ color: !getDisableStatus(row_data.name) ? "#f44336": "rgb(0,0,0,0.3)", marginRight: "0px" }}
              onClick={() => handleClickDeleteWS(row_data)}
              disabled = {getDisableStatus(row_data.name)}
            >
              <DeleteOutline fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      );
    } else {
      return <Typography variant="overline">Deleting...</Typography>;
    }
  };

  const columns = [
    { title: "Name", field: "name", editable: false },
    {
      title: "Created On",
      field: "created_date",
      type: "datetime",
      defaultSort: "desc",
      editable: false,
    },
    {
      title: "Updated On",
      field: "updated_date",
      type: "datetime",
      editable: false,
    },
    {
      title: "Description",
      field: "description",
    },
    { title: "URL", field: "url" },
    {
      title: "Actions",
      field: "name",
      render: (rowData) => {
        return renderActions(rowData);
      },
    },
  ];

  const fetchWebServiceListAndUpdateTable = () => {
    setIsLoading(true);
    //fetch webs service list and update table
    Actions("http_request", {
      url: "/sainapse/web_service",
      method: "get",
      data: {},
    })
      .then((response) => {
        let webServiceList = response.data.result;
        let data = [];
        let fields = columns.map((column) => column.field);

        data = webServiceList.map((webService) => {
          let webServiceInfoToShow = {};
          fields.forEach((fieldName) => [
            (webServiceInfoToShow[fieldName] = webService[fieldName]),
          ]);
          return webServiceInfoToShow;
        });
        setIsLoading(false);
        setWSData(data);
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorOpen(true);
        setErrorInfo(err);
      });
  };

  useEffect(fetchWebServiceListAndUpdateTable, []);

  return (
    <div style={{ width: "100%" }}>
      <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/web_service",
                        method : "GET",
                        operands : []
                      }}
                      shouldRenderErrorMessage = {true}
                      errorMessage = "User does not have sufficient privileges"
                      textVariant = "subtitle2"
                    >
      <MaterialTable
        title="Edge Service List"
        icons={tableIcons}
        columns={columns}
        data={wsData || []}
        isLoading={isLoading}
        // editable={{
        //   onRowUpdate: (newData, oldData) =>
        //     Actions("http_request", {
        //       url: `sainapse/web_service/${oldData["name"]}`,
        //       method: "put",
        //       data: {
        //         // name: newData.name,
        //         description: newData.description,
        //         url: newData.url,
        //       },
        //     })
        //       .then((response) => {
        //         let updatedWsInfo = response.data.result;
        //         let updatedData = data.map((wsInfo) => {
        //           if (wsInfo.name === updatedWsInfo.name) {
        //             return updatedWsInfo;
        //           }
        //           return wsInfo;
        //         });

        //         setData(updatedData);
        //       })
        //       .catch((err) => {
        //         setErrorOpen(true);
        //         setErrorInfo(err);
        //         // alert("web service updating failed!");
        //       }),
        //   onRowDelete: (oldData) =>
        //     Actions("http_request", {
        //       url: `sainapse/web_service/${oldData["name"]}`,
        //       method: "delete",
        //     })
        //       .then((response) => {
        //         if (response.data.deleted) {
        //           let updatedData = data.filter((dataItem) => {
        //             return dataItem.name !== oldData.name;
        //           });
        //           setData(updatedData);
        //         }
        //       })
        //       .catch((err) => {
        //         setErrorOpen(true);
        //         setErrorInfo(err);
        //         // alert("web service deletion failed!");
        //       }),
        // }}
        options={{
          actionsColumnIndex: -1,
          cellStyle: {
            height: "20px",
            paddingTop: 0,
            paddingBottom: 0,
          },
          toolbarButtonAlignment: "right",
          paging: false,
        }}
        components={{
          Toolbar: (props) => (
            <Fragment>
              <MTableToolbar {...props} />
              <Divider />
              <div style={{ display: "flex", flexDirection: "row-reverse" }}>
              <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/web_service",
                        method : "POST",
                        operands : []
                      }}
                    >
                <Tooltip title="Add Web Service">
                  <Button
                    style={{
                      margin: "10px",
                    }}
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<Add />}
                    onClick={handleClickAddNewWS}
                  >
                    Add Web Service
                  </Button>
                </Tooltip>
                </SecureWrapper>
                <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/web_service",
                        method : "GET",
                        operands : []
                      }}
                    >
                <Tooltip title="Refresh">
                  <Button
                    style={{
                      backgroundColor: "#039be5",
                      color: "#FFFFFF",
                      margin: "10px",
                    }}
                    variant="contained"
                    size="small"
                    startIcon={<Refresh />}
                    onClick={fetchWebServiceListAndUpdateTable}
                  >
                    Refresh
                  </Button>
                </Tooltip>
                </SecureWrapper>
              </div>
              <Divider />
            </Fragment>
          ),
        }}
      />
      </SecureWrapper>
      {/* <Button variant="contained" color="primary" onClick={handleClickOpen}>
        Add Web Service
      </Button> */}
      <AddWebService
        open={addWSOpen}
        handleClose={handleAddWSClose}
      ></AddWebService>
      <EditWebService
        open={editWSOpen}
        updateRowData={udpateRow}
        wsInfo={editingItem}
        handleClose={handleEditWSClose}
      ></EditWebService>
      <ErrorMessageAlert
        open={errorOpen}
        handleClose={handleErrorClose}
        errorInfo={errorInfo}
      ></ErrorMessageAlert>
      <DeleteConfirmationDialog
        open={confirmDeleteDialogOpen}
        name={deletingItem.name}
        type={"Web Service"}
        confirmDeleteHandler={confirmDelete}
        cancelDeleteHandler={cancelDelete}
      ></DeleteConfirmationDialog>
    </div>
  );
}
